"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringArrayCustomNode = void 0;
var StringArrayCustomNode;
(function (StringArrayCustomNode) {
    StringArrayCustomNode["StringArrayCallNode"] = "StringArrayCallNode";
    StringArrayCustomNode["StringArrayScopeCallsWrapperFunctionNode"] = "StringArrayScopeCallsWrapperFunctionNode";
    StringArrayCustomNode["StringArrayScopeCallsWrapperVariableNode"] = "StringArrayScopeCallsWrapperVariableNode";
})(StringArrayCustomNode || (exports.StringArrayCustomNode = StringArrayCustomNode = {}));
